
import { useState } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import BookingModal from '../home/components/BookingModal';

interface AccordionItem {
  title: string;
  content: string;
}

export default function ImpressumPage() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [openAccordion, setOpenAccordion] = useState<number | null>(0);

  const openBookingModal = () => setIsBookingModalOpen(true);
  const closeBookingModal = () => setIsBookingModalOpen(false);

  const toggleAccordion = (index: number) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  const accordionItems: AccordionItem[] = [
    {
      title: 'EU-Streitschlichtung',
      content: 'Gemäß Verordnung über Online-Streitbeilegung in Verbraucherangelegenheiten (ODR-Verordnung) möchten wir Sie über die Online-Streitbeilegungsplattform (OS-Plattform) informieren. Verbraucher haben die Möglichkeit, Beschwerden an die Online Streitbeilegungsplattform der Europäischen Kommission unter http://ec.europa.eu/odr zu richten. Die dafür notwendigen Kontaktdaten finden Sie oberhalb in unserem Impressum. Wir möchten Sie jedoch darauf hinweisen, dass wir nicht bereit oder verpflichtet sind, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.'
    },
    {
      title: 'Haftung für Inhalte dieser Webseite',
      content: 'Wir entwickeln die Inhalte dieser Webseite ständig weiter und bemühen uns korrekte und aktuelle Informationen bereitzustellen. Leider können wir keine Haftung für die Korrektheit aller Inhalte auf dieser Webseite übernehmen, speziell für jene die seitens Dritter bereitgestellt wurden. Sollten Ihnen problematische oder rechtswidrige Inhalte auffallen, bitten wir Sie uns umgehend zu kontaktieren, Sie finden die Kontaktdaten im Impressum.'
    },
    {
      title: 'Haftung für Links auf dieser Webseite',
      content: 'Unsere Webseite enthält Links zu anderen Webseiten für deren Inhalt wir nicht verantwortlich sind. Haftung für verlinkte Websites besteht laut § 17 ECG für uns nicht, da wir keine Kenntnis rechtswidriger Tätigkeiten hatten und haben, uns solche Rechtswidrigkeiten auch bisher nicht aufgefallen sind und wir Links sofort entfernen würden, wenn uns Rechtswidrigkeiten bekannt werden. Wenn Ihnen rechtswidrige Links auf unserer Website auffallen, bitten wir Sie uns zu kontaktieren, Sie finden die Kontaktdaten im Impressum.'
    },
    {
      title: 'Urheberrechtshinweis',
      content: 'Alle Inhalte dieser Webseite (Bilder, Fotos, Texte, Videos) unterliegen dem Urheberrecht. Falls notwendig, werden wir die unerlaubte Nutzung von Teilen der Inhalte unserer Seite rechtlich verfolgen. Sollten Sie auf dieser Webseite Inhalte finden, die das Urheberrecht verletzen, bitten wir Sie uns zu kontaktieren.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header onBookingClick={openBookingModal} />
      
      {/* Hero Section */}
      <section className="pt-32 pb-12 lg:pt-40 lg:pb-16 px-6 lg:px-12 bg-white">
        <div className="max-w-4xl mx-auto">
          <p className="text-sm text-[#042A60]/60 mb-4">
            01 / Informationspflicht laut §5 E-Commerce Gesetz,<br />
            §14 Unternehmensgesetzbuch, §63 Gewerbeordnung und<br />
            Offenlegungspflicht laut §25 Mediengesetz.
          </p>
          <h1 className="text-4xl lg:text-6xl text-[#042A60] mb-6 font-light">
            Impressum
          </h1>
        </div>
      </section>

      {/* Company Info Section */}
      <section className="py-12 lg:py-16 px-6 lg:px-12 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-6">
            <div>
              <p className="text-base text-[#042A60]/80 leading-relaxed">
                <strong>Mitglied bei:</strong> WKO Oberösterreich
              </p>
              <p className="text-base text-[#042A60]/80 leading-relaxed">
                <strong>Berufsrecht:</strong> Gewerbeordnung: www.ris.bka.gv.at
              </p>
              <p className="text-base text-[#042A60]/80 leading-relaxed">
                <strong>Aufsichts- und Gewerbebehörde:</strong> Bezirkshauptmannschaft Urfahr-Umgebung
              </p>
              <p className="text-base text-[#042A60]/80 leading-relaxed">
                <strong>Berufsbezeichnung:</strong> Unternehmensberatung
              </p>
              <p className="text-base text-[#042A60]/80 leading-relaxed">
                <strong>Verleihungsstaat:</strong> Österreich
              </p>
              <p className="text-base text-[#042A60]/80 leading-relaxed">
                <strong>Geschäftsführerin:</strong> Mag. Eva Barbier
              </p>
            </div>

            <div className="pt-4">
              <p className="text-base text-[#042A60]/80 leading-relaxed">
                <strong>Unternehmensgegenstand:</strong> Unternehmensberatung für KI & Automatisierungslösungen
              </p>
              <p className="text-base text-[#042A60]/80 leading-relaxed">
                <strong>UID-Nummer:</strong> ATU63379926
              </p>
              <p className="text-base text-[#042A60]/80 leading-relaxed">
                <strong>Firmenbuchnummer:</strong> FN458427 h
              </p>
              <p className="text-base text-[#042A60]/80 leading-relaxed">
                <strong>Firmenbuchgericht:</strong> Linz
              </p>
              <p className="text-base text-[#042A60]/80 leading-relaxed">
                <strong>Firmensitz:</strong> 4040 Pöstlingberg
              </p>
              <p className="text-base text-[#042A60]/80 leading-relaxed">
                <strong>Adresse:</strong> Götzlingstr. 45f, 4040 Pöstlingberg
              </p>
              <p className="text-base text-[#042A60]/80 leading-relaxed">
                <strong>E-Mail:</strong> <a href="mailto:eva@klar-ki.at" className="text-[#0A6AF0] hover:underline">eva@klar-ki.at</a>
              </p>
              <p className="text-base text-[#042A60]/80 leading-relaxed">
                <strong>Telefon:</strong> <a href="tel:+4369911413141" className="text-[#0A6AF0] hover:underline">+43 69911413141</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Accordion Section */}
      <section className="py-12 lg:py-16 px-6 lg:px-12 bg-[#F5F5F5]">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {accordionItems.map((item, index) => (
              <div key={index} className="bg-white overflow-hidden">
                <button
                  onClick={() => toggleAccordion(index)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-[#042A60]/5 transition-colors cursor-pointer"
                >
                  <span className="text-lg font-medium text-[#0A6AF0]">
                    {item.title}
                  </span>
                  <i className={`ri-${openAccordion === index ? 'subtract' : 'add'}-line text-xl text-[#042A60] flex-shrink-0 w-6 h-6 flex items-center justify-center`}></i>
                </button>
                {openAccordion === index && (
                  <div className="px-6 pb-5">
                    <p className="text-base text-[#042A60]/80 leading-relaxed">
                      {item.content}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <BookingModal isOpen={isBookingModalOpen} onClose={closeBookingModal} />
    </div>
  );
}